import { Injectable } from "@angular/core";
import { DataModel, MetaModel, WidgetModel } from "common/models/utility-models/base-model";
import { FormWidgetService } from "../form-widget.service";

import { SystemService } from "common/services/core-services/system.service";
import { BatchListDataService } from "common/services/data-services/custom-service/batch-service";
// import { FeedbackGridDataService } from "common/services/data-services/feedback-grid-data.service";
import { FeedbackMappingModel } from "common/models/page-models/Feedback-Mapping/feedback-mapping-data-model";
import { FeedbackMappingMetaModel } from "common/models/page-models/Feedback-Mapping/feedback-mapping-form-model";
import { FeedbackGridDataService } from "common/services/data-services/admin/feedback/feedback-grid-data.service";
import { FeedbackMappingFormDataService } from "common/services/data-services/admin/feedback-mapping/feedback-mapping-form-data.service";
import { StudentsGridDataService } from "common/services/data-services/admin/students/students-grid-data.service";

@Injectable({
    providedIn: 'root'
})
export class FeedbackMappingFormWidgetService extends FormWidgetService<FeedbackMappingModel> {
    constructor(protected ds: FeedbackMappingFormDataService, private systemService: SystemService, private batchlistservice : BatchListDataService, private feedbackListService: FeedbackGridDataService, private studentService: StudentsGridDataService) {
        super(ds);
    }

    getMetaModel(): MetaModel {
        const meta = new FeedbackMappingMetaModel();
        return meta.getMetaModel();
    }


     override prepareMetaModel(dataModel: DataModel, metaModel: FeedbackMappingMetaModel, routeData: WidgetModel): Promise<FeedbackMappingMetaModel> {
        return new Promise<FeedbackMappingMetaModel>((resolve, reject) => {
             
            this.batchlistservice.postData('').then((data) =>{
                metaModel.properties.batch_id.options = data.details;
                // console.log( metaModel.properties.batch_id.options = data.details)
            });
            this.feedbackListService.postData('').then((data) => {
                metaModel.properties.feedback_Form_Id.options = data.details;
                // console.log(metaModel.properties.feedback_Form_Id.options = data.details)
            });
            // student_ids
            this.studentService.postData('').then((data) => {
                metaModel.properties['students'].options = data.details.filter((student) => student.status === 1 || student.status === 3);
                metaModel.properties.student_idsList = metaModel.properties['students'].options 
                // console.log(metaModel.properties['students'].options)
            });
            
            resolve(metaModel);

        });
    }

}
